import React, { PropTypes } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  FlatButton,
  Checkbox,
  FontIcon,
  IconMenu,
  MenuItem,
  IconButton,
} from 'material-ui';

export const getStatus = template => {
  // workaround for draft created from "make a copy" feature
  if (template.completionPercent === 99.9) return 'new';
  if (!template.originalContractId) return 'Signed';
  if (
    !isNaN(template.completionPercent)
    && template.completionPercent !== null
    && template.completionPercent !== 100
  ) {
    return `${template.completionPercent}% completed`;
  }
  // if (template.signatures && template.signatures.length) {
  //   if (template.signatures.some(o => o.signedBy)) return 'Signed';
  //   return 'Awaiting Supplier Signature';
  // }
  if (
    !isNaN(template.completionPercent)
    && template.completionPercent !== null
  ) {
    return `${template.completionPercent}% completed`;
  }
  return template.status;
};

const TemplateListForRC = props => {
  const {
    title,
    templates = [],
    inSigning: {
      onClickFunc,
      onCheckFunc,
      checkedMap,
      buyerLogo,
      buyerName,
    } = {},
    deleteRateSheet,
    openRateDoc,
  } = props;
  const isInSigning = Boolean(onCheckFunc);
  const deleteRateSheetFunc = originalContractId => () => {
    const confirm = window.confirm('Are you sure you want to delete this rate sheet?');
    if (confirm) deleteRateSheet({ originalContractId });
  };
  const onClickOpen = template => () => {
    if (onClickFunc) onClickFunc(template.originalContractId || template._id);
    openRateDoc({
      url: `${template.magicLink}&jumpBackTo=${window.location.href}`,
      collection: template.originalContractId ? 'draft' : 'template',
      rateDocId: template.originalContractId || template._id,
      isInSigning,
      buyerLogo,
      buyerName,
    });
  };
  const onClickOpenDiffing = template => () => {
    if (onClickFunc) onClickFunc(template.originalContractId || template._id);
    openRateDoc({
      url: `${template.magicLinkForDiffing}&forDiffing=true`,
      isInSigning,
      buyerLogo,
      buyerName,
    });
  };
  return (
    <div style={{ marginTop: '1em', display: templates.length ? 'block' : 'none', textAlign: 'left' }}>
      <div style={{ marginBottom: '4px', fontSize: '16px' }}>{title || 'RATE SHEETS'}</div>
      {
        templates
          // .sort((a, b) => (new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()))
          .map(template => {
            return (
              <div
                key={template._id}
                style={{ width: '100%', borderBottom: '1px solid #e0e0e0', padding: '4px' }}
              >
                <div className="flex-tc-sb">
                  {
                    isInSigning && (
                      <Checkbox
                        style={{ width: '40px' }}
                        checked={checkedMap[template._id] ? checkedMap[template._id].checked : false}
                        disabled={checkedMap[template._id] ? checkedMap[template._id].disabled : false}
                        onCheck={(_, value) => onCheckFunc(value, template._id)}
                      />
                    )
                  }
                  <div style={{ width: 'calc(50% - 100px)', overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    <div className="flex-center">
                      <FontIcon
                        className="tc-icon-description"
                        color="rgba(0, 0, 0, 0.54)"
                        style={{ fontSize: '14px' }}
                      />&nbsp;&nbsp;{template.locationName} {template.originFrom === 'edited' ? <small>&nbsp;(new version)</small> : ''}
                    </div>
                    {template.buyerCreatedFrom ? <small>&nbsp;This rate sheet was a copy created from a <Link to={`/contracting/contract/${template.buyerCreatedFrom.split('|')[0]}/details`}>contract sent by supplier</Link>.</small> : ''}
                  </div>
                  <div style={{ width: 'calc(50% + 50px)', marginLeft: '16px' }} className="flex-tc-sb">
                    <div className="flex-center">
                      <small>
                        {moment.utc(template.startDate).format('DD MMM YYYY')} - {moment.utc(template.endDate).format('DD MMM YYYY')}
                      </small>
                      <small
                        style={{ marginLeft: '16px', minWidth: '100px', color: getStatus(template) === 'new' ? 'red' : 'initial' }}
                      >
                        {getStatus(template)}
                      </small>
                    </div>
                    {
                      (() => {
                        if (!isInSigning) {
                          if (template.activities.length) {
                            return (
                              <div
                                style={{ textAlign: 'center' }}
                              >
                                <Link
                                  to={`/contracting/template/${template.threadId}/logs?msgOnly=true`}
                                >
                                  <FlatButton
                                    label="View Msgs"
                                    style={{ border: '1px solid #00bcd4' }}
                                    secondary
                                  />
                                </Link>
                              </div>
                            );
                          }
                        }
                        if (template.magicLinkForDiffing) {
                          return (
                            <FlatButton
                              label="View Changes"
                              labelStyle={{ textTransform: 'none', padding: '2px', fontSize: '12px' }}
                              style={{ border: '1px solid #00bcd4', marginLeft: '16px' }}
                              secondary
                              onClick={onClickOpenDiffing(template)}
                            />
                          );
                        }
                        return <span/>;
                      })()
                    }
                    <FlatButton
                      label="Open"
                      style={{ border: '1px solid #00bcd4', marginLeft: '16px' }}
                      secondary
                      onClick={onClickOpen(template)}
                    />
                    {
                      Boolean(deleteRateSheet) && (
                        <IconMenu
                          iconButtonElement={<IconButton iconClassName="tc-icon-more-vert" style={{ paddingLeft: 0, width: '28px' }} iconStyle={{ color: '#616061' }} />}
                          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                          desktop
                        >
                          <MenuItem
                            primaryText="Delete Rate Sheet"
                            onClick={deleteRateSheetFunc(template.originalContractId)}
                          />
                        </IconMenu>
                      )
                    }
                  </div>
                </div>
                {
                  // Boolean(isInSigning && foundMessage) && (
                  //   <div style={{ marginTop: '8px', marginLeft: '16px', padding: '0 8px 8px', lineHeight: '20px' }}>
                  //     <div className="flex-tc-sb">
                  //       <div>
                  //         {
                  //           moment(foundMessage.createdAt).format('DD MMM YYYY H:mm')
                  //         } &nbsp;&nbsp;<b>{
                  //         foundMessage.message.bodyJson.subject
                  //       }</b>
                  //       </div>
                  //       <div>
                  //         {
                  //           foundMessage.actor
                  //         }
                  //       </div>
                  //     </div>
                  //     {
                  //       foundMessage.message.bodyJson.message
                  //     }
                  //   </div>
                  // )
                }
              </div>
            );
          })
      }
    </div>
  );
};

TemplateListForRC.propTypes = {
  title: PropTypes.string,
  inSigning: PropTypes.object,
  templates: PropTypes.array,
  deleteRateSheet: PropTypes.func,
  openRateDoc: PropTypes.func,
};

export default connect(null, {
  openRateDoc: payload => ({
    type: '{dummy-account} RateDocIframe_open',
    payload,
  }),
})(TemplateListForRC);



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/template-list-for-RC.jsx